import { ToastContainer } from "react-toastify";
import "./assets/styles/main.scss";
import MainPage from "./pages/MainPage";

const App = () => {
  return (
    <div className="app">
      <MainPage />
      <ToastContainer position="top-center" theme="colored" />
    </div>
  );
};

export default App;
